import React from "react";
import { useIntl, defineMessages } from "react-intl";

import verifiedIcon from "@/assets/icons/verified.svg";
import { Icon } from "@/components/ui";
import { cn } from "@/utils/cn";

const messages = defineMessages({
  verified: { id: "account.verified", defaultMessage: "Verified Account" },
});

interface VerificationBadgeProps {
  className?: string;
}

const VerificationBadge: React.FC<VerificationBadgeProps> = ({ className }) => {
  const intl = useIntl();

  return (
    <span data-testid="verified-badge">
      <Icon
        className={cn("w-4 text-secondary-500", className)}
        src={verifiedIcon}
        alt={intl.formatMessage(messages.verified)}
      />
    </span>
  );
};

export default VerificationBadge;
